import { render } from "./TButton.vue?vue&type=template&id=5b1c6b0c"
import script from "./TButton.vue?vue&type=script&lang=js"
export * from "./TButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__